export default function toKey<T extends Record<string, unknown>>(
  obj: T
): string {
  return JSON.stringify(obj, Object.keys(obj).sort())
}
